module.exports = __webpack_public_path__ + "img/brotherhood.1fe6b381.svg";